// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modalWrapper__fBT7N","closeButton":"closeButton__efB2d"};